<router-outlet></router-outlet>
<div class="loading-circle h-100 w-100" *ngIf="loadingRouteConfig">
  <img src="assets/images/shared/loading-circle.svg" width="50" height="50" alt="loading...">
</div>
